/**
 * Type guard for whether `content` has the basic shape that `validateContent`
 * iterates: a non-null object with array `fields` and array `rules`.
 *
 * Production form-config content always satisfies this. The guard exists to
 * protect callers (validator hooks, CherryPickModal, etc.) from crashing on
 * partial test fixtures or partial-init render states. If false, callers
 * should bail with an empty result rather than invoking `validateContent`.
 *
 * History: introduced after a Bundle 2 regression where `useDestinationValidator`
 * crashed in `ExportComposer.test.tsx` because the test's vi.mock provided
 * `{ export: { destinations: [] } }` without `fields`. Lifted to a shared
 * helper so all `validateContent` callers can apply the same guard
 * consistently.
 */
export function isValidContentShape(content) {
    if (content == null || typeof content !== 'object')
        return false;
    const c = content;
    return Array.isArray(c.fields) && Array.isArray(c.rules);
}
//# sourceMappingURL=content-shape.js.map